module.exports = __webpack_public_path__ + "img/logo_dark.e3256c19.svg";